// @flow

import * as React from "react";
import { useLocation, useHistory } from "react-router-dom";
import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    tabs: any[],
    cta?: any,
    className?: string,
};

const NavTabs = (props: PropsType): React.Node => {
    const location = useLocation();
    const history = useHistory();

    const cssBaseClass = "nav-tabs";
    const classList = [cssBaseClass];
    if (props.className) {
        classList.push(props.className);
    }

    return (
        <div className={classList.join(" ")}>
            <div className="nav-tabs__tab__inner">
                {props.tabs.map((tab, key) => {
                    return (
                        <LinkHandler
                            exact
                            key={key}
                            className="nav-tabs__tab"
                            activeClassName="nav-tabs__tab--active"
                            to={tab.to}
                        >
                            {tab.title}
                        </LinkHandler>
                    );
                })}
                <div className="nav-tabs__select__container">
                    <select
                        className="nav-tabs__select"
                        value={location.pathname}
                        onChange={event => history.push(event.target.value)}
                    >
                        {props.tabs.map((tab, key) => (
                            <option value={tab.to}>{tab.title}</option>
                        ))}
                    </select>
                    <div className="nav-tabs__select-indicator"></div>
                </div>
                {props.cta ? (
                    <div className="nav-tabs__cta">
                        <LinkHandler
                            className="button"
                            to={props.cta.url}
                            target={props.cta.target}
                        >
                            <span className="text">{props.cta.title}</span>
                        </LinkHandler>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default NavTabs;
